export const SUMO_SITE_ID_WAVE_UNSCREEN_RESTREAM = 'b8130700298bb800aabcd4000dffc50054474700015784009ce1c9008cf5f700'